import { defineComponent as p, ref as i, onMounted as d, onUpdated as v, provide as _, openBlock as h, createElementBlock as g, normalizeClass as k, createVNode as f, unref as t, withCtx as u, renderSlot as b } from "vue";
import { theme as C, themeOverrides as S } from "./ghl-ui.es259.js";
import "./ghl-ui.es260.js";
import "./ghl-ui.es261.js";
import { GHLLanguageKeys as a } from "./ghl-ui.es262.js";
import { date_en_US as s } from "./ghl-ui.es263.js";
import L from "./ghl-ui.es264.js";
import U from "./ghl-ui.es265.js";
import { sv as w } from "./ghl-ui.es266.js";
import { date_sv as B } from "./ghl-ui.es267.js";
import { es as P } from "./ghl-ui.es268.js";
import { date_es as y } from "./ghl-ui.es269.js";
import { ptBR as N } from "./ghl-ui.es270.js";
import { date_pt_BR as R } from "./ghl-ui.es271.js";
import { ptPT as A } from "./ghl-ui.es272.js";
import { date_pt_PT as F } from "./ghl-ui.es273.js";
import { no as x } from "./ghl-ui.es274.js";
import { date_no as z } from "./ghl-ui.es275.js";
import { it as I } from "./ghl-ui.es276.js";
import { date_it as T } from "./ghl-ui.es277.js";
import { de as W } from "./ghl-ui.es278.js";
import { date_de as $ } from "./ghl-ui.es279.js";
import { frFR as D } from "./ghl-ui.es280.js";
import { date_fr_FR as E } from "./ghl-ui.es281.js";
import { frCA as G } from "./ghl-ui.es282.js";
import { date_fr_CA as H } from "./ghl-ui.es283.js";
import { fi as K } from "./ghl-ui.es284.js";
import { date_fi as M } from "./ghl-ui.es285.js";
import { nl as O } from "./ghl-ui.es286.js";
import { date_nl as V } from "./ghl-ui.es287.js";
import { da as j } from "./ghl-ui.es288.js";
import { date_da as q } from "./ghl-ui.es289.js";
import { enUS as c } from "./ghl-ui.es290.js";
const J = p({
  name: "UIContentWrap",
  inheritAttrs: !0
}), Q = p({
  ...J,
  props: {
    fullScreen: {
      type: Boolean,
      default: !1
    },
    locale: {
      type: String,
      default: a.englishUS
    }
  },
  setup(l) {
    const o = l, e = i(c), r = i(s), m = () => {
      switch (function() {
        return o != null && o.locale ? o.locale.includes("_") ? (console.warn(
          `Deprecated used of '_' in the language '${o.locale}', please change to use hyphen '-'.`
        ), o.locale.replace("_", "-")) : o.locale : a.englishUS;
      }()) {
        case a.englishUS:
        default: {
          e.value = c, r.value = s;
          break;
        }
        case a.danish: {
          e.value = j, r.value = q;
          break;
        }
        case a.dutch: {
          e.value = O, r.value = V;
          break;
        }
        case a.finnish: {
          e.value = K, r.value = M;
          break;
        }
        case a.frenchCanada: {
          e.value = G, r.value = H;
          break;
        }
        case a.frenchFrance: {
          e.value = D, r.value = E;
          break;
        }
        case a.german: {
          e.value = W, r.value = $;
          break;
        }
        case a.italian: {
          e.value = I, r.value = T;
          break;
        }
        case a.norwegian: {
          e.value = x, r.value = z;
          break;
        }
        case a.portuguesePortugal: {
          e.value = A, r.value = F;
          break;
        }
        case a.portugueseBrazil: {
          e.value = N, r.value = R;
          break;
        }
        case a.spanish: {
          e.value = P, r.value = y;
          break;
        }
        case a.swedish: {
          e.value = w, r.value = B;
          break;
        }
      }
    };
    return d(() => {
      m();
    }), v(() => {
      m();
    }), _("customLocale", e), (n, X) => (h(), g("div", {
      class: k(["font-sans hl-wrapper-container", { "full-screen": l.fullScreen }])
    }, [
      f(t(L), {
        theme: t(C),
        "theme-overrides": t(S),
        locale: e.value,
        "date-locale": r.value
      }, {
        default: u(() => [
          f(t(U), null, {
            default: u(() => [
              b(n.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["theme", "theme-overrides", "locale", "date-locale"])
    ], 2));
  }
}), Ae = Q;
export {
  Ae as default
};
